module.exports = __webpack_public_path__ + "assets/img/5_1191_big.a53d3b97.jpg";